import React from "react";
import PropTypes from "prop-types";

export default function Icon({
  className = "",
  color = null,
  filled = false,
  id,
  name = "",
  onClick = () => {},
  role = "img",
  size = null,
  style = {},
}) {
  if (filled) name += "-filled";

  const classNames = [`icon-${name}`];
  if (className) {
    classNames.push(className);
  }

  let sizeStyles = {}
  if (size) {
    sizeStyles = {
      height: `var(--icon-size-${size})`,
      width: `var(--icon-size-${size})`,
      minHeight: `var(--icon-size-${size})`,
      minWidth: `var(--icon-size-${size})`,
      backgroundColor: color
    }
  }

  return (
    <span
      className={classNames.join(" ")}
      id={id}
      onClick={onClick}
      style={{...sizeStyles, ...style}}
      role={role}
      aria-label={name}
    ></span>
  );
}

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  filled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  role: PropTypes.string,
  size: PropTypes.oneOf(["xSmall", "small", "medium", "large", "xLarge"]),
  style: PropTypes.object,
}
